import React, { useState, useEffect } from "react";
import ajax from "superagent";
import { DateType } from "./filters/DateTab";

export type Event = {
  id: number;
  slug: string;
  name: string;
  startDate: string;
  browsePhotosPath: string;
  logo: { logo: { small: { url: string }; url: string } };
  location: string;
};

type Hook = (
  keywords: string | null,
  date: DateType | null
) => { events: Event[]; loading: boolean; error: string };

const useFilteredEvents: Hook = (keywords, date) => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    if (keywords)
      ajax
        .get("api/v1/search_events/keywords")
        .query({
          q: keywords
        })
        .then(response => {
          setLoading(false);
          setEvents(response.body.events);
        })
        .catch(err => {
          setLoading(false);
          setError(err.message);
        });
  }, [keywords]);

  useEffect(() => {
    setLoading(true);
    if (date)
      ajax
        .get("api/v1/search_events/date")
        .query({
          date: date.day ? `${date.day}-${date.month + 1}-${date.year}` : null,
          month: date.month + 1,
          year: date.year
        })
        .then(response => {
          setLoading(false);
          setEvents(response.body.events);
        })
        .catch(err => {
          setLoading(false);
          setError(err.message);
        });
  }, [date]);

  return {
    error,
    loading,
    events
  };
};

export default useFilteredEvents;
